import { useRouter } from 'next/router'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import s from './styles.module.scss'

import { SubscribeSimplifiedModalTypeEnum } from '../utils/subscribe-simplified-modal-type.enum'
import { LoginModalTypeEnum } from '../../login.enum'
import { SetLoginModalTypeProps } from '../../login.types'
import { Button, IconSvg } from '../../../../atoms'
import { Modal } from '../../../../molecules'

const SubscribeSimplifiedNotProfessionalEmailModal = ({
  setModalSubscribeSimplifiedType,
  setModalType,
}: {
  setModalSubscribeSimplifiedType: React.Dispatch<
    React.SetStateAction<SubscribeSimplifiedModalTypeEnum>
  >
  setModalType: SetLoginModalTypeProps
}) => {
  const router = useRouter()

  return (
    <Modal
      isOpen={true}
      title={
        <div className={s.titleWrapper}>
          <IconSvg.ArrowLeft
            onClick={() => {
              setModalSubscribeSimplifiedType(
                SubscribeSimplifiedModalTypeEnum.ACCESS_RESULTS,
              )
            }}
            className={s.icon}
          />
          <p className={s.title}>
            <FormattedMessage
              id='ui.subscribeSimplifiedNotProfessionalEmailModal.title'
              defaultMessage='Pas d’e-mail professionnel ?'
            />
          </p>
        </div>
      }
      className={s.subscribeSimplifiedNotProfessionalEmailModal}
      applyInnerStyle={false}
      navBar={
        <div className={s.headerMobile}>
          <IconSvg.ArrowLeft
            onClick={() => {
              setModalSubscribeSimplifiedType(
                SubscribeSimplifiedModalTypeEnum.ACCESS_RESULTS,
              )
            }}
            className={s.icon}
          />
          <p className={s.title}>
            <FormattedMessage
              id='ui.subscribeSimplifiedNotProfessionalEmailModal.title'
              defaultMessage='Pas d’e-mail professionnel ?'
            />
          </p>
        </div>
      }
    >
      <p className={s.textHelper}>
        <FormattedMessage
          id='ui.subscribeSimplifiedNotProfessionalEmailModal.textHelper'
          defaultMessage='Si vous ne disposez pas d’un e-mail professionnel avec un nom de domaine personnalisé, notre équipe peut valider manuellement votre identité professionnelle et créer un accès en quelques instants :'
        />
      </p>

      <Button
        onClick={() => {
          router.back()
          setModalType({ type: LoginModalTypeEnum.Close })
        }}
        fullWidth={true}
        className={s.contactButton}
      >
        <FormattedMessage
          id='ui.subscribeSimplifiedNotProfessionalEmailModal.contactTeam'
          defaultMessage='Contacter l’équipe'
        />
      </Button>
    </Modal>
  )
}

export default SubscribeSimplifiedNotProfessionalEmailModal
